import { Link } from "react-router-dom";
import { LEGAL_NAV, COMPANY } from "@/content/legal";

const cols = [
  {
    h: "AI Voice Agent",
    l: [
      { t: "Overview", to: "/ai/overview" },
      { t: "Inbound AI Calls", to: "/ai/inbound" },
      { t: "Outbound AI Calls", to: "/ai/outbound" },
      { t: "Web Chat & Widget", to: "/ai/web-chat" },
      { t: "Multilingual", to: "/ai/multilingual" },
      { t: "Analytics & Insights", to: "/ai/analytics" },
    ],
  },
  {
    h: "PBX Platform",
    l: [
      { t: "Multi-Tenant PBX", to: "/pbx/multi-tenant" },
      { t: "Features", to: "/pbx/features" },
      { t: "Numbers & Coverage", to: "/numbers" },
      { t: "Softphone & Portal", to: "/pbx/softphone" },
      { t: "Security & Reliability", to: "/pbx/security" },
      { t: "Analytics & Reporting", to: "/pbx/analytics" },
    ],
  },
  {
    h: "Partners",
    l: [
      { t: "Become a Reseller", to: "/partners/reseller" },
      { t: "White-Label Program", to: "/partners/white-label" },
      { t: "Affiliate Program", to: "/partners/affiliate" },
    ],
  },
  {
    h: "Company",
    l: [
      { t: "Pricing", to: "/pricing" },
      { t: "Guides", to: "/guides" },
      { t: "Documentation", to: "/docs" },
      { t: "Compare", to: "/compare" },
      { t: "About", to: "/about" },
      { t: "Careers", to: "/careers" },
      { t: "Book a Demo", to: "/demo" },
    ],
  },
];

export const Footer = () => (
  <footer className="relative bg-[#0a0a0a] text-white pt-20 pb-10 overflow-hidden" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <img src="/brand/ownpbx-mark.png" alt="" width="36" height="36" className="w-9 h-9" />
            <span className="font-heading font-medium text-lg">OwnPBX<sup className="text-[0.5em] align-super font-semibold ml-px">™</sup></span>
          </Link>
          <p className="mt-4 text-neutral-400 text-sm max-w-xs leading-relaxed">
            A phone system that answers, talks and sells for you — powered by AI, on infrastructure you control.
          </p>
        </div>
        {cols.map((col) => (
          <div key={col.h}>
            <p className="font-mono-t text-[11px] uppercase tracking-widest text-neutral-500">{col.h}</p>
            <ul className="mt-4 space-y-2.5">
              {col.l.map((x) => (
                <li key={x.to + x.t}>
                  <Link to={x.to} className="text-sm text-neutral-400 hover:text-white transition-colors">{x.t}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-16 flex items-center justify-between border-t border-white/10 pt-6 flex-wrap gap-4">
        <p className="font-mono-t text-xs text-neutral-500">© {new Date().getFullYear()} OwnPBX™. All rights reserved.</p>
        <nav aria-label="Legal" className="flex flex-wrap gap-x-5 gap-y-2">
          {LEGAL_NAV.map((n) => (
            <Link key={n.to} to={n.to} className="font-mono-t text-xs text-neutral-500 hover:text-white transition-colors">{n.t}</Link>
          ))}
          <a href={`mailto:${COMPANY.email}`} className="font-mono-t text-xs text-neutral-500 hover:text-white transition-colors">{COMPANY.email}</a>
        </nav>
        <p className="font-mono-t text-xs text-neutral-500">EN · हिंदी · Hinglish</p>
      </div>

      <h2 className="mt-14 font-heading font-medium tracking-tighter text-center leading-none text-[19vw] text-white/[0.05] select-none pointer-events-none">
        OwnPBX
      </h2>
    </div>
  </footer>
);
